import React from 'react';

const Articles = () => {
    return (
      <div>
        
        <iframe src="https://enbybase.blogspot.com/" title="article" frameborder="0" style={{ display: 'block', width: '100%', height: '100vh' }}></iframe>

        
      </div>
    );
  }

export default Articles;